import { defineComponent as _defineComponent } from 'vue'
import CURadioButton from '@/components/CURadioButton.vue'
  import {URMRole, URMRoleKey,} from '@/models/dto/userRoleManagement'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UserRoleSelector',
  props: {
    modelValue: null,
    userRoles: null,
    disabledUserRoles: { default: () => [] },
    message: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:model-value', value: string): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: URMRoleKey, userRoles: URMRole[], disabledUserRoles: URMRole[], message?: string };

  

  

  const selectUserRole = (userRole: URMRole) => {
    if (isDisabled(userRole.key)) {
      return
    }
    emit('update:model-value', userRole.key)
  }

  const isDisabled = (roleKey: string) => {
    return props.disabledUserRoles.some(role => role.key === roleKey)
  }

  const isSelected = (roleKey: string) => {
    return props.modelValue === roleKey
  }

return { __sfc: true,props, emit, selectUserRole, isDisabled, isSelected, CURadioButton }
}

})